import { Button, Input } from '@lokalise/louis'
import type { Integrations } from '@lokalise/translation-api-schemas'
import baseProfile from '../../../../assets/baseProfile.svg'
import { AI_PROFILES_DOCUMENTATION_URL } from '../../../../constants/url'
import { AiModelSelect } from '../../../AiModelSelect/AiModelSelect'
import {
  StepContainer,
  StepContents,
  StepFooter,
  StepRSP,
  StepSubtitle,
  StepTitle,
  StepTitleContainer,
} from '../../../Step/Step'
import { StyledLink } from '../../../StyledLink/StyledLink'
import styles from './BaseProfileBasicsStep.module.css'

type BaseProfileBasicsStepProps = {
  name: string
  selectedAiModel: Integrations
  isLoading: boolean
  onAiModelSelected: (aiModel: Integrations) => void
  onSubmit: () => void
  onClose: () => void
}

export const BaseProfileBasicsStep = ({
  name,
  selectedAiModel,
  isLoading,
  onAiModelSelected,
  onSubmit,
  onClose,
}: BaseProfileBasicsStepProps) => (
  <StepContainer>
    <StepContents>
      <StepTitleContainer>
        <StepTitle>Basic settings</StepTitle>
        <StepSubtitle>
          This step allows to change basic profile settings, such as the LLM provider. Routing is
          enabled by default, as it ensures the best translation quality{' '}
          <StyledLink href={AI_PROFILES_DOCUMENTATION_URL} rel="noreferrer" target="_blank">
            docs.
          </StyledLink>
        </StepSubtitle>
      </StepTitleContainer>
      <div className="flex-col gap-5">
        <div className="flex-col gap-2">
          <span className={styles.heading} id="name-input">
            Name AI profile
          </span>
          <Input
            autoFocus
            disabled
            aria-labelledby="name-input"
            placeholder="Profile name"
            value={name}
          />
        </div>
        <AiModelSelect selectedModel={selectedAiModel} onModelChange={onAiModelSelected} />
      </div>
      <StepFooter>
        <Button variant="tertiary" onClick={onClose}>
          Cancel
        </Button>
        <Button loading={isLoading} disabled={isLoading} onClick={onSubmit} variant="primary">
          Update
        </Button>
      </StepFooter>
    </StepContents>
    <StepRSP>
      <img alt="overview" src={baseProfile} />
    </StepRSP>
  </StepContainer>
)
